export default __webpack_public_path__ + "static/media/black_bronze_horn.4f71ba0a.png";